// PastMeetsCard.jsx
import { Card, CardBody } from "@heroui/card";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { isMeetingActive } from "@/utils/dates";

const PastMeetsCard = ({ _record }) => {
  const navigate = useNavigate();

  const activeMeets = useMemo(() => {
    return isMeetingActive(_record.meeting_date, _record.start_time.set, _record.end_time.set);
  }, [_record.meeting_date, _record.start_time.set, _record.end_time.set]);

  return (
    <Card isPressable disableRipple className="w-full h-full shadow-lg"
      onPress={() => navigate(`/meetings/view/${_record.short_code}`)}>
      <CardBody className="px-4 py-2">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold text-default-800 capitalize">
            {_record.title}
          </h3>
          <small className="text-primary">
            {_record.start_time.set} - {_record.end_time.set}
          </small>
        </div>

        <p className="text-sm text-neutral-700 dark:text-zinc-100 mt-1 line-clamp-3">
          {_record.description === "" ? (
            <span className="italic text-neutral-400 dark:text-zinc-400">
              No Description...
            </span>
          ) : (
            <span>{_record.description}</span>
          )}
        </p>
      </CardBody>
    </Card>
  );
};

export default PastMeetsCard;